var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
/* eslint-disable indent */
import styled from 'styled-components';
export default styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", " {\n    display: block;\n    margin-bottom: ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.cssPrefix;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing_03;
});